import { useEffect } from 'react';
import { useQuery } from '@/lib/hooks/use-query';
import { GET_ORDER_ACTION_COUNTS } from '@/lib/graphql/operations/reports';

interface OrderActionCounts {
  unfulfilled: number;
  awaitingPayment: number;
  pendingReturns: number;
}

const POLL_INTERVAL = 60_000; // 60 seconds

/**
 * Polls orderActionCounts every 60s for sidebar nav badges.
 * Returns state-based counts (not unseen — clears when merchant acts, not when they view).
 */
export function useOrderActionCounts() {
  const { data, refetch } = useQuery<{ orderActionCounts: OrderActionCounts }>(
    GET_ORDER_ACTION_COUNTS,
    {},
  );

  useEffect(() => {
    const interval = setInterval(() => refetch(), POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [refetch]);

  const counts = data?.orderActionCounts;

  return {
    ordersBadge: (counts?.unfulfilled ?? 0) + (counts?.awaitingPayment ?? 0),
    returnsBadge: counts?.pendingReturns ?? 0,
  };
}
